'use strict';

var moment = require('moment-timezone');
var Marionette = require('backbone.marionette');
var template = require('./templates/list-item.hbs');

export default Marionette.View.extend({
  tagName: 'li',
  template: template,

  constructor: function (options) {
    this.attributes = {
      'data-id': options.model.id,
    };
    this.distance = options.distance;
    this.waitTime = options.waitTime;
    this.isShowWaitTimeOn = options.isShowWaitTimeOn;
    Marionette.View.prototype.constructor.apply(this, arguments);
  },

  serializeData: function () {
    var json = this.model.toJSON();

    json.showWaitTime = this.isShowWaitTimeOn && this.model.shouldShowWaitTime();
    json.showInfoIcon = !json.virtual;
    if (json.showWaitTime && this.waitTime) {
      json.waitTime = this.waitTime.get('waitTime');
    }

    if (this.distance) {
      var distanceInKm = this.distance.toFixed(1);
      var distanceInMiles = (distanceInKm / 1.609344).toFixed(1);
      json.distance = distanceInKm + 'km / ' + distanceInMiles + 'mi';
    } else {
      json.distance = null;
    }

    return json;
  },

  select: function () {
    this.$el.addClass('active');
  },

  deselect: function () {
    this.$el.removeClass('active');
  },

});
